module.exports = __webpack_public_path__ + "img/sign.b28bc2ea.png";